import React, { useState, useMemo } from "react";
import Stack from "react-bootstrap/Stack";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCirclePlus,
  faArrowRotateRight,
  faFileContract,
} from "@fortawesome/free-solid-svg-icons";
import Spinner from "react-bootstrap/Spinner";
import { useCookies } from "react-cookie";
// components
import { deleteCustomerSetData } from "../../../context/api/delete/customer/deleteCustomerSetData";
import DataTable from "../../dynamic-components/DataTable";
import CreateCustomerModal from "../../utils/modals/customer-modal/CreateCustomerModal";
import SearchBar from "../../dynamic-components/SearchBar";
import ConfirmModal from "../../dynamic-components/ConfirmModal";

const HomeTable = ({
  lang,
  setShowFullModal,
  tableData,
  loader,
  setRefreshData,
  btnLoader,
  getPdf,
}) => {
  const dataTranslate = require(`../../../translate/${lang === "AR" ? "arabic" : "english"
    }/data.json`);
  const searchByData = dataTranslate.pages.home_p.table.table_head.search_by;
  
  const initialAddModal = {
    isShow: false,
    action: "",
    rowData: {},
  };

  const initialConfirmModal = {
    isShow: false,
    rowData: {},
  };

  const initialSuccessMessage = {
    success: false,
    type: "",
    data: {},
  };
  const initialMessageRes = {
    success: Boolean,
    message: String,
    isShow: false,
  };

  const [cookies] = useCookies();
  const [showAddModal, setShowAddModal] = useState(initialAddModal);
  const [confirmModal, setConfirmModal] = useState(initialConfirmModal);
  const [confirmBtnLoader, setConfirmBtnLoader] = useState(false);
  const [messageResponse, setMessageResponse] = useState(initialMessageRes);
  const [successMessage, setSuccessMessage] = useState(initialSuccessMessage);

  const action = {
    title: dataTranslate.popups.home_p.delete_modal.title,
    submit: dataTranslate.popups.home_p.delete_modal.submit,
  };

  const [search, setSearch] = useState({
    type: "fullName",
    value: "",
  });

  const handleSearch = (e) => {
    const value = e.target.value || undefined;
    setSearch((prev) => ({ ...prev, value: value }));
  };
  const searchOptions = [
    { key: "fullName", value: searchByData.name },
    { key: "phoneNumber", value: searchByData.phone_num },
    { key: "customer_code", value: searchByData.code },
  ];

  const columns = useMemo(
    () => [
      {
        Header: dataTranslate.pages.home_p.table.table_body.client_id,
        accessor: "id",
      },
      {
        Header: dataTranslate.pages.home_p.table.table_body.client_name,
        accessor: "fullName",
      },
      {
        Header: dataTranslate.pages.home_p.table.table_body.phone_num,
        accessor: "phoneNumber",
      },
      {
        Header: dataTranslate.pages.home_p.table.table_body.createdAt_date,
        accessor: "creation_date",
        Cell: ({ cell }) => {
          return <div>{cell.row.original.creation_date.split("T")[0]}</div>;
        },
      },
      {
        Header: dataTranslate.pages.home_p.table.table_body.client_code,
        accessor: "customer_code",
      },
      {
        Header: dataTranslate.pages.home_p.table.table_body.action,
        Cell: ({ cell }) => {
          return (
            <div className="d-flex gap-3">
              <button
                className="home_p-table-table-body-btn"
                onClick={() =>
                  setShowAddModal((prev) => ({
                    ...prev,
                    isShow: true,
                    action: "update",
                    rowData: cell.row.original,
                  }))
                }
              >
                {dataTranslate.pages.home_p.table.table_body.edit}
              </button>
              <button
                className="home_p-table-table-body-btn"
                onClick={() =>
                  setShowFullModal((prev) => ({
                    ...prev,
                    isShow: true,
                    data: cell.row.original,
                  }))
                }
              >
                {dataTranslate.pages.home_p.table.table_body.show}
              </button>
              <button
                className="home_p-table-table-body-btn-delete"
                onClick={() =>
                  setConfirmModal((prev) => ({
                    ...prev,
                    isShow: true,
                    rowData: cell.row.original,
                  }))
                }
              >
                {dataTranslate.pages.home_p.table.table_body.delete}
              </button>
            </div>
          );
        },
      },
    ],
    []
  );

  const deleteCustomer = async (id) => {
    setConfirmBtnLoader(() => true);
    await deleteCustomerSetData(
      lang,
      setMessageResponse,
      cookies,
      id,
      setSuccessMessage
    );
    setConfirmBtnLoader(() => false);
  };

  return (
    <div className="home_p-table w-100 d-flex flex-column align-items-center">
      <div className="home_p-table-nav w-100 m-3 px-3">
        <Stack direction="horizontal" gap={3}>
          <div
            className="home_p-table-nav-btn"
            onClick={() =>
              setShowAddModal((prev) => ({
                ...prev,
                isShow: true,
                action: "add",
              }))
            }
          >
            <span>{dataTranslate.pages.home_p.table.table_head.add}</span>
            <FontAwesomeIcon
              icon={faCirclePlus}
              size="xl"
              style={{ color: "#f2ce00" }}
            />
          </div>

          <div className="home_p-table-nav-btn" onClick={() => getPdf()}>
            {btnLoader ? (
              <Spinner animation="border" variant="warning" />
            ) : (
              <span>{dataTranslate.pages.home_p.table.table_head.report}</span>
            )}
            <FontAwesomeIcon
              icon={faFileContract}
              size="xl"
              style={{ color: "#f2ce00" }}
            />
          </div>

          <div
            className={
              lang === "AR"
                ? "ms-auto home_p-table-nav-btn"
                : "me-auto home_p-table-nav-btn"
            }
            onClick={() => {
              setRefreshData((prev) => prev + 1);
            }}
          >
            <span>{dataTranslate.pages.home_p.table.table_head.refresh}</span>
            <FontAwesomeIcon
              icon={faArrowRotateRight}
              size="xl"
              style={{ color: "#f2ce00" }}
            />
          </div>
          <SearchBar
            lang={lang}
            search={search}
            handleSearch={handleSearch}
            options={searchOptions}
            setSearch={setSearch}
          />
        </Stack>
      </div>

      <div className="home_p-table-table w-100 m-3 px-3">
        <ConfirmModal
          show={confirmModal.isShow}
          onHide={() => setConfirmModal(initialConfirmModal)}
          post={deleteCustomer}
          data={confirmModal.rowData}
          lang={lang}
          dataTranslate={dataTranslate}
          setRefreshData={setRefreshData}
          action={action}
          btnLoader={confirmBtnLoader}
          successMessage={successMessage}
          setSuccessMessage={setSuccessMessage}
        />

        <CreateCustomerModal
          show={showAddModal.isShow}
          onHide={() => setShowAddModal(initialAddModal)}
          lang={lang}
          dataTranslate={dataTranslate}
          action={showAddModal.action}
          data={showAddModal.rowData}
          setRefreshData={setRefreshData}
        />
        <DataTable
          lang={lang}
          columns={columns}
          dataTable={tableData}
          pageClass="home_p"
          showEditModal
          loader={loader}
          search={search}
        />
      </div>
    </div>
  );
};

export default HomeTable;
